import React from 'react'

/**
 * What the customer is signing right now, published by the guided signing
 * flow and read by the signature dialog (comps/Signature) to show a header:
 * step title, what it means, "View agreement" and the sign-all notice. A tiny
 * external store keeps the ~15 report modals untouched (ticket 13197251229).
 */
export interface GuidedHeader {
  field: string
  title: string
  description: string
  index: number
  total: number
  /** Labels this one signature will be applied to (sign-all), or null. */
  signAllLabels: string[] | null
  viewContract(): void
  /** Signing v2: "Part 1 of 2" / "Part 2 of 2", or null with a single card. */
  part?: string | null
}

let current: GuidedHeader | null = null
const listeners = new Set<() => void>()

export function setGuidedHeader(header: GuidedHeader | null): void {
  current = header
  listeners.forEach((listener) => listener())
}

const subscribe = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
const snapshot = () => current

/** The guided header for `field`, or null when that field is not the current step. */
export function useGuidedHeader(field: string): GuidedHeader | null {
  const header = React.useSyncExternalStore(subscribe, snapshot, snapshot)
  return header && header.field === field ? header : null
}
